// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    recessionData,
    calloutValue,
    calloutLabel,
  } = props;

  function replaceCharacter(val) {
    return val.replace(/_/g, ' ');
  }

  // const xTicks = isMobile ? 5 : 10;
  const yTicks = isMobile ? 8 : 8;

  // const ticksMobi = ['1/1/1930', '1/1/1940', '1/1/1950', '1/1/1960', '1/1/1970', '1/1/1980', '1/1/1990', '1/1/2000', '1/1/2010', '1/1/2020'];
  const ticksMobi = [
    '1/1/2020',
    '2/1/2020',
    '3/1/2020',
    '4/1/2020',
    '5/1/2020',
    '6/1/2020',
    '7/1/2020',
    '8/1/2020',
    '9/1/2020',
    '10/1/2020',
    '11/1/2020',
    '12/1/2020',
  ];

  const dates = {
    January: 'Jan.',
    March: 'March',
    May: 'May',
    July: 'July',
    September: 'Sept.',
    November: 'Nov.',
    December: 'Dec.',
  };

  const xGrid = xAxis(x)
    // .ticks(xTicks)
    .tickValues(ticksMobi.map(d => new Date(d)))
    .tickFormat(d => (isMobile
      ? dates[fmtMonth(d)]
      : dates[fmtMonth(d)]));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${replaceCharacter(d.id)}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickFormat(d => `${(d / 1000)}M`));

  // yGrid.select('text').style('display', 'none'); // hide first tick's text
  yGrid.selectAll('line').attr('x2', width);

  // recessions
  const recessions = g.append('g')
    .attr('class', 'recessions');

  recessions.selectAll('.recession')
    .data(recessionData)
    .enter().append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[x(d.start), 0]})`)
    .attr('width', d => x(d.end) - x(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.00);
  // .style('fill-opacity', 0.09);

  recessions.append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x(new Date('2/1/2020')) + 5, 15]})`)
    .attr('text-anchor', 'start');
  // .text('Recession');

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', d => `line line-${d.id}`);

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .attr('transform', (d) => {
      // console.log(d);
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      // const d0 = (d.id === 'Projection') ? d.values.find((val, index, arr) => index === arr.length - 1) : null;
      const x0 = x(d0[0].date) + 5;
      const y0 = y(d0[0].value) + 3;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'start')
    .text((d) => {
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      const { value } = d0[0];
      // console.log(value, data);
      // return isMobile ? `-${((152463 - value) / 1000).toFixed(1)}M` : `-${((152463 - value) / 1000).toFixed(1)}M`;
      return d.id;
    });
/*
  label.append('text')
    .attr('transform', (d) => {
      // console.log(d);
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      const x0 = x(d0[0].date) + 5;
      const y0 = y(d0[0].value) + (isMobile ? 18 : 20);
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'start')
    .text((d) => {
      const d0 = d.values.filter((obj) => {
        if (obj.date.getTime() == x.domain()[1].getTime()) {
          return obj;
        }
      });
      const { value } = d0[0];
      return isMobile ? 'since Feb.' : 'since Feb.';
    }); */
}
